import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../../hook/use-http";
import NoTableData from ".././NoTableData";
import { ThreeCircles } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../../redux/userSlice";
import styles from '.././EnergyPageCustom_Kratos.module.css'
import WaterMark from "../../DashboardMain_Kratos/WaterMark";

export default function ConsumptionTables_Kratos({ gloablfilter, singleVinSelected }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [topping, setTopping] = useState("Net");
  const [net_consumption, setNetConsumption] = useState([]);
  const [energy_consumption, setEnergyConsumption] = useState([]);

  const net_consumption_resp = (data) => {
    setNetConsumption(data);
  }
  const energy_consumption_resp = (data) => {
    setEnergyConsumption(data);
  }

  const [TBTextNet, setTBTextNet] = useState("Top")

  // const changeTopping = (selectOp) => {
  //   setTopping(selectOp)
  //   // fetchData({ url: API_URL_MAIN + "energy_analysis_bus/net_consumption", body: { filterdata: gloablfilter, orderBy: selectOp } }, net_consumption_resp)
  // }
  const changeTopping = (e) => {
    setTopping(e.target.value)
    // fetchData({ url: API_URL_MAIN + "energy_analysis_bus/net_consumption", body: { filterdata: gloablfilter, orderBy: selectOp } }, net_consumption_resp)
  }

  const changeTBNet = (selectOp) => {
    setTBTextNet(selectOp)
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/net_consumption", body: { filterdata: gloablfilter, orderBy: selectOp } }, net_consumption_resp)
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/energy_consumption", body: { filterdata: gloablfilter, orderBy: selectOp } }, energy_consumption_resp)
  }

  // const [TBTextEnergy, setTBTextEnergy] = useState("Top")
  // const changeTBEnergy = (selectOp) => {
  //   setTBTextEnergy(selectOp)
  //   fetchData({ url: API_URL_MAIN + "energy_analysis_bus/energy_consumption", body: { filterdata: gloablfilter, orderBy: selectOp } }, energy_consumption_resp)
  // }

  useEffect(() => {
    setTBTextNet('top')
    // setTBTextEnergy('top')
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/net_consumption", body: { filterdata: gloablfilter, orderBy: 'top' } }, net_consumption_resp)
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/energy_consumption", body: { filterdata: gloablfilter, orderBy: 'top' } }, energy_consumption_resp)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)

  // code for pop up
  const appyDataModal = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  }
  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };
  const handlePlatformChange = (event) => {
    const toggel = event.target.value
    if (toggel === "optioncharging")
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/pop_up_one", body: { filterdata: gloablfilter } }, appyDataModal)
    else
      fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/pop_up_one_outlier", body: { filterdata: gloablfilter } }, appyDataModal)
  }

  const [toShowRadio, setToShowRadio] = useState("totChrgCycle")
  const [currentRadioValue, setCurrentRadioValue] = useState("optioncharging")
  const [modaldata, setModaldata] = useState([]);
  const loadModalData = (event) => {
    const dataTag = event.currentTarget.dataset.tag;
    setToShowRadio(dataTag)
    setCurrentRadioValue("optioncharging")
    fetchData({ url: API_URL_MAIN + "kratos_energy_analytics/pop_up_one", body: { filterdata: gloablfilter, dataTag: dataTag } }, appyDataModal)
  }
  // code for pop up

  return (
    <>
      <div className="modal fade" id="energy_summary" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              {
                toShowRadio === "totChrgCycle" ?
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-check form-check-inline">
                        <input className="form-check-input_kratos" type="radio" name="inlineRadioOptionsCharging" id="inlineRadio1" value="optioncharging" checked={currentRadioValue === 'optioncharging'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                        <label className="form-check-label" htmlFor="inlineRadio1">&nbsp; Cycles</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input_kratos" type="radio" name="inlineRadioOptionsOutlires" id="inlineRadio2" value="optionoutliers" checked={currentRadioValue === 'optionoutliers'} onChange={handleRadioChange} onClick={handlePlatformChange} />
                        <label className="form-check-label" htmlFor="inlineRadio2">&nbsp; Outliers</label>
                      </div>
                    </div>
                  </div>
                  :
                  <h5 className="modal-title" id="exampleModalLabel">{toShowRadio === "criticalFaultyCycle" ? (<>Cycles</>) : (<>Cycles</>)}</h5>
              }
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="tablecontainer" style={{ overflowX: "scroll", minHeight: "300px" }}>
                <table className="table table-striped" style={{ width: "100%" }}>
                  <thead className={`${styles.popUpTable}`}>
                    <tr>
                      <th scope="col">Cycle</th>
                      <th scope="col">vehicleId</th>
                      <th scope="col">Registration Number</th>
                      <th scope="col">startTime</th>
                      <th scope="col">endTime</th>
                      <th scope="col">startOdo</th>
                      <th scope="col">endOdo</th>
                      <th scope="col">distanceInKM</th>
                      <th scope="col">Range</th>
                      <th scope="col">KWh_Remain_start</th>
                      <th scope="col">KWh_Remain_End</th>
                      <th scope="col">NetkWh</th>
                      <th scope="col">kwh_km</th>
                      <th scope="col">dataNet_kWh_km</th>
                      <th scope="col">dataCons_kWh_km</th>
                      <th scope="col">dataRegen_kWh_km</th>
                      <th scope="col">motorConsumption_km</th>
                      <th scope="col">aux1Load_km</th>
                      <th scope="col">aux2Load_km</th>
                      <th scope="col">dcdcLoad_km</th>
                      <th scope="col">remLoad</th>
                      <th scope="col">remLoad_km</th>
                      <th scope="col">remLoad_Fr</th>
                      <th scope="col">error1</th>
                      <th scope="col">error2</th>
                      <th scope="col">error3</th>
                      <th scope="col">LOB</th>
                      <th scope="col">PL</th>
                      <th scope="col">PPL</th>
                      <th scope="col">DLR_NAME</th>
                      <th scope="col">DLR_STATE</th>
                      <th scope="col">DLR_ORG_CITY</th>
                      {/* <th scope="col">bcs1Load_km</th> */}
                      {/* <th scope="col">bcs2Load_km</th> */}
                      {/* <th scope="col">B_KWh_Remain_start</th> */}
                      {/* <th scope="col">C_KWh_Remain_start</th> */}
                      {/* <th scope="col">D_KWh_Remain_start</th> */}
                      {/* <th scope="col">B_KWh_Remain_End</th> */}
                      {/* <th scope="col">C_KWh_Remain_End</th> */}
                      {/* <th scope="col">D_KWh_Remain_End</th> */}
                      {/* <th scope="col">VCU_BMS_No_of_Packs</th> */}
                      {/* <th scope="col">dataNet_kWh</th> */}
                      {/* <th scope="col">dataCons_kWh</th> */}
                      {/* <th scope="col">dataRegen_kWh</th> */}
                      {/* <th scope="col">motorConsumption</th> */}
                      {/* <th scope="col">acConsumption</th> */}
                      {/* <th scope="col">acLoadIdle</th> */}
                      {/* <th scope="col">acLoadDrive</th> */}
                      {/* <th scope="col">aux1Load</th> */}
                      {/* <th scope="col">aux2Load</th> */}
                      {/* <th scope="col">bcs1Load</th> */}
                      {/* <th scope="col">bcs2Load</th> */}
                      {/* <th scope="col">dcdcLoad</th> */}
                      {/* <th scope="col">acConsumption_km</th> */}
                      {/* <th scope="col">acLoadIdle_km</th> */}
                      {/* <th scope="col">acLoadDrive_km</th> */}
                      {/* <th scope="col">dataCons_kWh_Fr</th> */}
                      {/* <th scope="col">dataRegen_kWh_Fr</th> */}
                      {/* <th scope="col">motorConsumption_Fr</th> */}
                      {/* <th scope="col">acConsumption_Fr</th> */}
                      {/* <th scope="col">aux1Load_Fr</th> */}
                      {/* <th scope="col">aux2Load_Fr</th> */}
                      {/* <th scope="col">bcs1Load_Fr</th> */}
                      {/* <th scope="col">bcs2Load_Fr</th> */}
                      {/* <th scope="col">dcdcLoad_Fr</th> */}
                      {/* <th scope="col">DLR_REGION</th> */}
                      {/* <th scope="col">FIRST_SALE_DT</th> */}
                      {/* <th scope="col">rn</th> */}
                      {/* <th scope="col">Depot_Name</th> */}
                      {/* <th scope="col">Smart_City</th> */}
                      {/* <th scope="col">air_ventilation</th> */}
                    </tr>
                  </thead>
                  <tbody>

                    {isLoading ? loader : (modaldata.length == 0) ? <tr><td colSpan='17' className="alert alert-danger no_data" style={{ background: "#f4c2ce" }}>No records found</td></tr> : modaldata.map((x, index) => {
                      return (<tr key={index}>
                        <td scope="row">{index + 1}</td>
                        <td scope="row">{x._source.vehicleId}</td>
                        <td scope="row">{x._source.vehicle_registration_number}</td>
                        <td scope="row">{x._source.startTime}</td>
                        <td scope="row">{x._source.endTime}</td>
                        <td scope="row">{x._source.startOdo}</td>
                        <td scope="row">{x._source.endOdo}</td>
                        <td scope="row">{x._source.distanceInKM}</td>
                        <td scope="row">{x._source.Range}</td>
                        <td scope="row">{x._source.KWh_Remain_start}</td>
                        <td scope="row">{x._source.KWh_Remain_End}</td>
                        <td scope="row">{x._source.NetkWh}</td>
                        <td scope="row">{x._source.kwh_km}</td>
                        <td scope="row">{x._source.dataNet_kWh_km}</td>
                        <td scope="row">{x._source.dataCons_kWh_km}</td>
                        <td scope="row">{x._source.dataRegen_kWh_km}</td>
                        <td scope="row">{x._source.motorConsumption_km}</td>
                        <td scope="row">{x._source.aux1Load_km}</td>
                        <td scope="row">{x._source.aux2Load_km}</td>
                        <td scope="row">{x._source.dcdcLoad_km}</td>
                        <td scope="row">{x._source.remLoad}</td>
                        <td scope="row">{x._source.remLoad_km}</td>
                        <td scope="row">{x._source.remLoad_Fr}</td>
                        <td scope="row">{x._source.error}</td>
                        <td scope="row">{x._source.error1}</td>
                        <td scope="row">{x._source.error2}</td>
                        <td scope="row">{x._source.LOB}</td>
                        <td scope="row">{x._source.PL}</td>
                        <td scope="row">{x._source.PPL}</td>
                        <td scope="row">{x._source.DLR_NAME}</td>
                        <td scope="row">{x._source.DLR_STATE}</td>
                        <td scope="row">{x._source.DLR_ORG_CITY}</td>
                        {/* <td scope="row">{x._source.bcs1Load_km}</td> */}
                        {/* <td scope="row">{x._source.bcs2Load_km}</td> */}
                        {/* <td scope="row">{x._source.B_KWh_Remain_start}</td> */}
                        {/* <td scope="row">{x._source.C_KWh_Remain_start}</td> */}
                        {/* <td scope="row">{x._source.D_KWh_Remain_start}</td> */}
                        {/* <td scope="row">{x._source.B_KWh_Remain_End}</td> */}
                        {/* <td scope="row">{x._source.C_KWh_Remain_End}</td> */}
                        {/* <td scope="row">{x._source.D_KWh_Remain_End}</td> */}
                        {/* <td scope="row">{x._source.VCU_BMS_No_of_Packs}</td> */}
                        {/* <td scope="row">{x._source.dataNet_kWh}</td>
                        <td scope="row">{x._source.dataCons_kWh}</td>
                        <td scope="row">{x._source.dataRegen_kWh}</td>
                        <td scope="row">{x._source.motorConsumption}</td>
                        <td scope="row">{x._source.acConsumption}</td>
                        <td scope="row">{x._source.acLoadIdle}</td>
                        <td scope="row">{x._source.acLoadDrive}</td>
                        <td scope="row">{x._source.aux1Load}</td>
                        <td scope="row">{x._source.aux2Load}</td>
                        <td scope="row">{x._source.bcs1Load}</td>
                        <td scope="row">{x._source.bcs2Load}</td>
                        <td scope="row">{x._source.dcdcLoad}</td>
                        */}
                        {/* <td scope="row">{x._source.acConsumption_km}</td> */}
                        {/* <td scope="row" className="text-start">{x._source.acLoadIdle_km}</td> */}
                        {/* <td scope="row">{x._source.acLoadDrive_km}</td> */}
                        {/* <td scope="row">{x._source.dataCons_kWh_Fr}</td> */}
                        {/* <td scope="row">{x._source.dataRegen_kWh_Fr}</td> */}
                        {/* <td scope="row">{x._source.motorConsumption_Fr}</td> */}
                        {/* <td scope="row">{x._source.acConsumption_Fr}</td> */}
                        {/* <td scope="row">{x._source.aux1Load_Fr}</td> */}
                        {/* <td scope="row">{x._source.aux2Load_Fr}</td> */}
                        {/* <td scope="row">{x._source.bcs1Load_Fr}</td> */}
                        {/* <td scope="row">{x._source.bcs2Load_Fr}</td> */}
                        {/* <td scope="row">{x._source.dcdcLoad_Fr}</td> */}
                        {/* <td scope="row">{x._source.DLR_REGION}</td> */}
                        {/* <td scope="row">{x._source.FIRST_SALE_DT}</td> */}
                        {/* <td scope="row">{x._source.rn}</td> */}
                        {/* <td scope="row">{x._source.Depot_Name}</td> */}
                        {/* <td scope="row">{x._source.Smart_City}</td> */}
                        {/* <td scope="row">{x._source.air_ventilation}</td> */}
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-12 col-md-6 col-sm-12 pr-0">
          <div className={`${styles.energyChartboxNew_Kratos}`}>
            <WaterMark />
            <div className={`v-title ${styles.energyTitleChart_Kratos}`}>
              <div className="row p-1">
                <div className="col-lg-10 equal-cols">
                  <div className="form-check form-check-inline kratos pl-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="NetCons"
                      id="NetCons"
                      value="Net"
                      checked={topping === "Net"}
                      onClick={changeTopping}
                    />
                    <label className="form-check-label" htmlFor="FaultyVehicleCount">
                      Net Consumption (Kwh/Km)
                    </label>
                  </div>
                  <div className="form-check form-check-inline kratos pl-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="EnergyCons"
                      id="EnergyCons"
                      value="Energy"
                      checked={topping === "Energy"}
                      onClick={changeTopping}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="PercentageOfFaultyVehicle"
                    >
                      Energy Consumption (Kwh/Km)
                    </label>
                  </div>
                  {/* <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTopping(event.target.value)} value={topping} style={{ paddingRight: '1px' }}>
                      <option value="Net">Net Consumption (Kwh/Km)</option>
                      <option value="Energy">Energy Consumption (Kwh/Km)</option>
                  </select> */}
                </div>
                {/* <div className="col-md-6"></div> */}
                <div className="col-lg-2 text-end">
                  {(gloablfilter.VIN_NUM.length === 1) ?
                    <button className="pt-0 pb-0 pl-1 pr-1 btn btn_sm btn_summary" data-tag="totChrgCycle"
                      data-bs-toggle={gloablfilter.VIN_NUM.length === 1 ? "modal" : undefined}
                      data-bs-target={gloablfilter.VIN_NUM.length === 1 ? "#energy_summary" : undefined}
                      style={gloablfilter.VIN_NUM.length === 1 ? { cursor: "pointer" } : undefined}
                      onClick={gloablfilter.VIN_NUM.length === 1 ? loadModalData : undefined}>Summary</button>
                    :
                    <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTBNet(event.target.value)} value={TBTextNet} style={{ paddingRight: '1px' }}>
                      <option value="top">Top 10</option>
                      <option value="bottom">Bottom 10</option>
                    </select>
                  }
                </div>
              </div>
            </div>
            <div className={`${styles.tableContent_Kratos} px-2`} style={{ overflowY: 'scroll', height: '222px' }}>
              {(topping === 'Net') ?
                <table className="table table-striped tablecolumn">
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: "sticky", top: 0 }}>
                    <tr>
                      <th scope="col">Vin</th>
                      <th scope="col">Reg. Number</th>
                      <th scope="col">City</th>
                      <th scope="col">Depo</th>
                      <th scope="col">CF</th>
                    </tr>
                  </thead>
                  <tbody>

                    {(net_consumption.length === 0) ? <NoTableData /> : net_consumption.map(x => {
                      return (<tr key={x.key.vehicleId}>
                        <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                        <td>{x.key.vehicle_registration_number}</td>
                        <td>{x.key.DLR_ORG_CITY}</td>
                        <td>{x.key.Depot_Name}</td>
                        <td>{(x.dataNet_kWh_per_km.value).toFixed(2)}</td>
                      </tr>)
                    })}

                  </tbody>
                </table> :
                <table className="table table-striped tablecolumn">
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: "sticky", top: 0 }}>
                    <tr>
                      <th scope="col">Vin</th>
                      <th scope="col">Reg. Number</th>
                      <th scope="col">City</th>
                      <th scope="col">Depo</th>
                      <th scope="col">CF</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(energy_consumption.length == 0) ? <NoTableData /> : energy_consumption.map(x => {
                      return (<tr key={x.key.vehicleId}>
                        <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                        <td>{x.key.vehicle_registration_number}</td>
                        <td>{x.key.DLR_ORG_CITY}</td>
                        <td>{x.key.Depot_Name}</td>
                        <td>{(x.dataCons_kWh_per_km.value).toFixed(2)}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
        {/* same code 2 */}
        {/* <div className="col-lg-6 col-md-6 col-sm-12 pr-0">
          <div className="energyChartboxNew_Bus">
            <WaterMark />
            <div className="v-title energyTitleChart_Bus">
              <div className="row p-1">
                <div className="col-lg-8 mt-1">
                  <div className=""><b>Energy Consumption (Kwh/Km)</b></div>
                </div>
                <div className="col-lg-4 text-end">
                  {(gloablfilter.VIN_NUM.length === 1) ?
                    ""
                    :
                    <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTBEnergy(event.target.value)} value={TBTextEnergy} style={{ paddingRight: '1px' }}>
                      <option value="top">Top 10</option>
                      <option value="bottom">Bottom 10</option>
                    </select>
                  }

                </div>
              </div>
            </div>
            <div className="tableContent_Bus px-2" style={{ overflowY: 'scroll', height: '222px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: "sticky", top: 0 }}>
                  <tr>
                    <th scope="col">Vin</th>
                    <th scope="col">CF</th>
                  </tr>
                </thead>
                <tbody>
                  {(energy_consumption.length == 0) ? <NoTableData /> : energy_consumption.map(x => {
                    return (<tr key={x.key.vehicleId}>
                      <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                      <td>{(x.dataCons_kWh_per_km.value).toFixed(2)}</td>
                    </tr>)
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
        {/* same code 2 */}
      </div>


    </>
  )
}
